import { createFileRoute } from "@tanstack/react-router";
import Admin from "@/pages/Admin";
import { AuthenticationMethod } from "@aqualis/common/types";
import { AuthProvider } from "@/contexts/auth-context";

export const Route = createFileRoute("/admin")({
  component: AdminPage,
});

function AdminPage() {
  return (
    <AuthProvider authMethod={AuthenticationMethod.Cookie}>
      <Admin />
    </AuthProvider>
  );
}
